import { Button, Dialog, InputBase } from '@mui/material';
import React from 'react';

import { Icons } from '../../../assets/SvgIcons';
import classes from './../../../components/UI/TodoCard/TodoCard.module.css';

interface DeleteDialogProps {
  open: boolean;
  handleClose: (close: boolean) => void;
  deleteAction: () => void;
  dealspaceName: string;
}

export default function DeleteWorkspace(props: DeleteDialogProps) {
  const { open, handleClose, deleteAction, dealspaceName } = props;
  const [userDealspaceName, setUserDealspaceName] = React.useState('');

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="add-user-dialog"
      >
        <div className="dialog-header">
          <div className={classes.deleteTaskHeader}>Delete {dealspaceName}</div>
          <button
            className="dialog-close-button"
            onClick={() => {
              setUserDealspaceName('');
              handleClose(false);
            }}
          >
            <Icons.Cancel width="22" height="22" color="#000000" />
          </button>
        </div>

        <div className="dialog-content">
          <div className={classes.infoTextDelete}>
            Deleting the dealspace will permanently erase the details and files
            of your deal. Make sure you have a back up of all the relevent
            information and data.
          </div>
          <div
            style={{
              color: '#BF2600',
              fontFamily: 'Inter',
              marginTop: 5,
              fontWeight: '600',
            }}
          >
            This action can not be undone.
          </div>
          <div style={{ paddingTop: 30 }}>
            <div className="enter_your_mail ">
              Enter the dealspace name to delete
            </div>
            <InputBase
              className={['dialogInputBase dialogInpuaholder auth_input'].join(
                ' '
              )}
              value={userDealspaceName}
              onChange={evt => {
                setUserDealspaceName(evt.target.value);
              }}
              style={{ padding: '4px 10px 5px' }}
              placeholder="Enter the dealspace name to delete"
            />
          </div>
          <div style={{ marginTop: 20 }}></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className={classes.infoTextDelete}></div>
            <div>
              <Button
                className={classes.CancelButton}
                onClick={() => {
                  setUserDealspaceName('');
                  handleClose(false);
                }}
              >
                Cancel
              </Button>
              <Button
                className={classes.DeleteButton}
                style={{
                  opacity: dealspaceName === userDealspaceName ? '1' : '0.4',
                }}
                onClick={() => {
                  if (dealspaceName === userDealspaceName) {
                    deleteAction();
                    setUserDealspaceName('');
                    handleClose(false);
                  }
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
        <div></div>
      </Dialog>
    </div>
  );
}
